/** @format */

import { request } from '@power/runtime-vue3';
import type { BaseResponse } from '@power/runtime-vue3';

// 获取字典分类列表
export function getTypeList(params: { pageNum: number; pageSize: number }) {
	return request<{
		rows: {
			dictName: string;
			dictType: string;
		}[];
	}>(
		{
			url: '/system/dict/type/list',
			method: 'get',
			params,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 查询字典数据列表
export function listData(query: any) {
	return request<{
		rows: {
			dictLabel: string;
			dictValue: string;
		}[];
	}>(
		{
			url: '/system/dict/data/list',
			method: 'get',
			params: query,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 查询字典数据详细
export function getData(dictCode) {
	return request<BaseResponse<any>>(
		{
			url: `/system/dict/data/${dictCode}`,
			method: 'get',
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
	return request<{
		data: {
			dictLabel: string;
			dictValue: string;
			listClass: string;
			cssClass: string;
		}[];
	}>(
		{
			url: `/system/dict/data/type/${dictType}`,
			method: 'get',
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 新增字典数据
export function addData(data) {
	return request<BaseResponse<any>>(
		{
			url: '/system/dict/data',
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 修改字典数据
export function updateData(data) {
	return request<BaseResponse<any>>(
		{
			url: '/system/dict/data',
			method: 'put',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 删除字典数据
export function delData(dictCode) {
	return request<BaseResponse<any>>(
		{
			url: `/system/dict/data/${dictCode}`,
			method: 'delete',
		},
		{
			isGetDataDirectly: false,
		},
	);
}
// 按照id查询
export function resource(id) {
	return request<BaseResponse<any>>(
		{
			url: `base/oss/resource/getById/${id}`,
			method: 'get',
		},
		{
			isGetDataDirectly: false,
		},
	);
}
